module.exports = __webpack_public_path__ + "static/media/png.f453144e.png";